<template>
  <div class="rightconover">
    <div class="contentwidth" v-loading="loading" 
      :element-loading-text="config.loading.text"
      :element-loading-spinner="config.loading.spinner"
      :element-loading-background="config.loading.background">
      <div class="ContentMargin">
        <div class="content_head">
          <div class="content_head_ico">
            <img
              src="@/assets/images/estorage/content_title_ico_blue.png"
              alt=""
            />
          </div>
          <div class="content_head_title">轮换计划明细</div>
          <div class="content_head_button">
            <el-radio-group v-model="tabPosition" @change="tabPosition_cahange">
              <el-radio-button label="outstore">轮出</el-radio-button>
              <el-radio-button label="instore">轮入</el-radio-button>
            </el-radio-group>
            <div class="content_head_seek">
              <el-date-picker
                v-model="year"
                value-format="yyyy"
                type="year"
                placeholder="选择计划年度">
              </el-date-picker>
            </div>
            <lk-button img="search.png" @click="search" style="margin-left:20px"></lk-button>
            <!-- <el-button type="primary">审批</el-button> -->
          </div>
        </div>
        <div class="schedule_table">
          <div class="table_content">
              <el-table
            :data="Schedule"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="foodKind"
              label="粮食品种"
              fixed
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="getYear"
              sortable
              label="收获年份"
              align="center"
              width="120"
            >
            </el-table-column>
            <el-table-column
              prop="barName"
              label="仓房名称"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="foodLever"
              label="粮食等级"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="grainBelong"
              label="粮权所属"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="depotCn"
              label="所属粮库"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="grainNature"
              label="粮食性质"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="pruductArea"
              label="产地"
              width="120"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="barWeights"
              sortable
              label="实际容量(吨)"
              fixed="right"
              align="center"
              width="140"
            >
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="200">
              <template slot-scope="scope">
                <el-button
                  @click="gotocheck('详情', scope.row.id)"
                  v-if="scope.row.pId"
                  size="mini"
                  >查看通知单</el-button
                >
                <el-button
                  v-else
                  @click="gotocheck('新增', scope.row.id)"
                  type="success"
                  size="mini"
                  >新增通知单</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          </div>
          <div class="paging">
            <div class="block">
              <el-pagination
                background
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                layout="total, prev, pager, next, jumper"
                :total="totalPage"
              >
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  checkisnull
} from "@/utils/util";
import { httpToken } from "@/utils/http";
import { mapMutations } from "vuex";
import qs from "qs";
export default {
  name: "Detailed",
  data() {
    return {
      // 当前库点id
      resunit:JSON.parse(sessionStorage.user).unitId,
      Schedule:[],
      // loading 展示文字 1 2为文件上传loading 3为文件获取loading
      loading_textshow:1,
      loading:false,
      // 历史构造器
      datasearchjson:[],
      // 类型 0 出 1入
      data_planType:0,
      currentPage: 1,
      year:'',
      totalPage: 0,
      tabPosition: "outstore",
    };
  },
  mounted(){
    this.getdatalb(1)
  },
  methods: {
    ...mapMutations("Manage", [
      "setNoticesState",
      "setNoticesId",
      "setNoticesStatus"
    ]),
    // 跳转查看方法
    gotocheck(title, id) {
      this.setNoticesState(title);
      if (id) {
        this.setNoticesId(id);
      }
      // //通知单类型:0入库 1出库 2移库 3轮换出库通知书 4轮换入库通知书
      this.setNoticesStatus(4)
      this.$store.commit("setgraincheckshowurl", this.$store.state.leftNav)
      this.$emit('update:comName', 'PlanNoticeNotice')
    },
     search_return() {
      let jsons=[
      ];
      if(!checkisnull(this.year)){
        jsons.push({column: "get_year",type: 'eq', value: this.year})
      }
      return jsons;
    },
    search() {
      let searchjson=this.search_return();
      console.log('search_return',searchjson)
      this.getdatalb(1,searchjson);
    },
    tabPosition_cahange(val){
      if(val=='outstore'){
        this.data_planType=0
      }else{
        this.data_planType=1
      }
      this.getdatalb(1)
    },
    getdatalb(val,searchjson){
      // planType 0出 1入
      // loading 展示文字 1 2为文件上传loading 3为文件获取loading
      // this.loading_textshow=1
      this.loading=true;
      this.currentPage=val;
      let json = [
        { column: "create_date", type: "orderByDesc"},
        { column: "plan_type", type: "eq",value:this.data_planType},
        { column: "unit", type: 'eq',value:this.resunit },
        {type: "or"},
        { column: "depot", type: "eq",value:this.resunit},
        { column: "plan_type", type: "eq",value:this.data_planType},
        { column: "create_date", type: "orderByDesc"}
      ];
      if(searchjson){
        if(searchjson.__proto__.constructor===Array){
          for(let i=0;i<searchjson.length;i++){
            json.push(searchjson[i])
            json.unshift(searchjson[i])
          }
        }else{
          json.push(searchjson)
          json.unshift(searchjson)
        }
      }
      this.datasearchjson=searchjson;
      httpToken({
        method: "post",
        url: "/group-plan-inoutplan-makeoutplan/list",
        data:qs.stringify({
          page:val,
          paramData: JSON.stringify(json),
          rows:10
        }),
      }).then((res) => {
        let resdata=res.data.data;
        console.log('resdata',resdata)
        if(res.data.code==200){
          if (val !== res.data.data.current) {
            this.getdatalb(res.data.data.pages,searchjson);
            return
          }
          this.totalPage=resdata.total;
          resdata.records.forEach(item => {
            item.barWeights=item.barWeights/1000
          });
          this.Schedule=resdata.records;
        }
        this.loading=false;
      }).catch(()=>{
        this.loading=false;
      })
    },
    // 选择分页
    handleCurrentChange(val) {
      this.getdatalb(val,this.datasearchjson);
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/model_kuang.scss";  //引入方式

.content_head {
  display: flex;
  font-size: 18px;
  margin-bottom: 50px;

  .content_head_ico {
    height: 17px;
    width: 4px;
    margin: auto 10px auto 0;

    img {
      width: 100%;
      height: 100%;
      display: block;
    }
  }

  .content_head_title {
    margin: auto 0;
  }

  .content_head_button {
    margin-left: auto;

    ::v-deep .el-button {
      margin-left: 10px;
      padding: 10px;
      font-size: 16px;

      span {
        font-size: 14px;
      }
    }

    .content_head_seek {
      display: inline-block;
      vertical-align: top;
      margin-left: 20px;
      width: 12.5vw;

      ::v-deep .el-date-editor,
      .el-select {
        width: 100%;
      }
    }
  }

  .content_head_button_spacing {
    margin-top: 20px;
    text-align: right;
  }
}

.schedule_table {
  .table_content {
    margin-bottom: 100px;

    ::v-deep .el-table th {
      background-color: #f5f8ff;
    }

    ::v-deep .el-table thead {
      color: #000000;
    }
  }
}
.dialogWidth {
  width: 550px;
  min-width: 550px;
}
.dialogtitle {
  width: 100%;
  display: flex;
  height: 50px;
  line-height: 20px;
  padding: 15px;
  box-sizing: border-box;
  background: #f5f6fa;
  margin-bottom: 20px;
  div {
    width: 50%;
  }
}
.el-form {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    width: 50%;
    ::v-deep .el-select {
      width: 100%;
    }
  }
}
</style>
